/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationRelationDto
 */
export interface OrganizationRelationDto {
    /**
     * 
     * @type {string}
     * @memberof OrganizationRelationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRelationDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationRelationDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRelationDto
     */
    parentId: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRelationDto
     */
    organizationType: OrganizationRelationDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRelationDto
     */
    mainLanguage: OrganizationRelationDtoMainLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRelationDto
     */
    createdById?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRelationDto
     */
    updatedById?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationRelationDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationRelationDto
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const OrganizationRelationDtoOrganizationTypeEnum = {
    Operator: 'Operator',
    Manufacturer: 'Manufacturer',
    Landlord: 'Landlord',
    Oem: 'OEM'
} as const;
export type OrganizationRelationDtoOrganizationTypeEnum = typeof OrganizationRelationDtoOrganizationTypeEnum[keyof typeof OrganizationRelationDtoOrganizationTypeEnum];

/**
 * @export
 */
export const OrganizationRelationDtoMainLanguageEnum = {
    En: 'en',
    Fr: 'fr',
    De: 'de'
} as const;
export type OrganizationRelationDtoMainLanguageEnum = typeof OrganizationRelationDtoMainLanguageEnum[keyof typeof OrganizationRelationDtoMainLanguageEnum];


/**
 * Check if a given object implements the OrganizationRelationDto interface.
 */
export function instanceOfOrganizationRelationDto(value: object): value is OrganizationRelationDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('mainLanguage' in value) || value['mainLanguage'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function OrganizationRelationDtoFromJSON(json: any): OrganizationRelationDto {
    return OrganizationRelationDtoFromJSONTyped(json, false);
}

export function OrganizationRelationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationRelationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'active': json['active'],
        'parentId': json['parentId'],
        'organizationType': json['organizationType'],
        'mainLanguage': json['mainLanguage'],
        'createdById': json['createdById'] == null ? undefined : json['createdById'],
        'updatedById': json['updatedById'] == null ? undefined : json['updatedById'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function OrganizationRelationDtoToJSON(json: any): OrganizationRelationDto {
    return OrganizationRelationDtoToJSONTyped(json, false);
}

export function OrganizationRelationDtoToJSONTyped(value?: OrganizationRelationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
        'parentId': value['parentId'],
        'organizationType': value['organizationType'],
        'mainLanguage': value['mainLanguage'],
        'createdById': value['createdById'],
        'updatedById': value['updatedById'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

